var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIndicatorError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#E94D7B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.646 4.804l-.84.841L8.168 9.01l-3.363 3.364.84.841L9.01 9.85l3.364 3.364.841-.84-3.364-3.365 3.364-3.364-.84-.84L9.01 8.167 5.646 4.804z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/indicator-error.4ea61045529b1dbe8ed25add6f1b7d0b.svg";
export { SvgIndicatorError as ReactComponent };